import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import authReducer from './slices/authSlice';
import preferencesReducer from './slices/preferencesSlice';
import cacheReducer from './slices/cacheSlice';
import locationReducer from './slices/locationSlice';

// Configuration de la persistance Redux
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'preferences', 'cache', 'location'],
  transforms: [
    {
      in: (state, key) => {
        if (key === 'auth' || key === 'preferences' || key === 'cache' || key === 'location') {
          // Supprimer les erreurs et le statut de chargement lors de la persistance
          return {
            ...state,
            error: null,
            loading: false
          };
        }
        return state;
      },
      out: (state, key) => {
        if (key === 'auth' || key === 'preferences' || key === 'cache' || key === 'location') {
          // Réinitialiser les erreurs et le statut de chargement lors de la restauration
          return {
            ...state,
            error: null,
            loading: false
          };
        }
        return state;
      }
    }
  ]
};

// Combinaison des reducers
const rootReducer = combineReducers({
  auth: authReducer,
  preferences: preferencesReducer,
  cache: cacheReducer,
  location: locationReducer
});

// Création du reducer persistant
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    })
});

export const persistor = persistStore(store);

export default store;
